const skills = [
  {
    id: 1,
    title: "Back End",
    image: "backend_blue.png",
    languages: [
      {
        id: 1,
        title: "php",
        css: "php",
      },
      {
        id: 2,
        title: "Laravel",
        css: "laravel",
      },
      {
        id: 3,
        title: "WordPress",
        css: "wordpress",
      },
      {
        id: 4,
        title: "Node.js",
        css: "nodejs",
      },
    ],
    description:
      "I develop web apps using php, Laravel, WordPress and Node.js and work closely with relational databases to deliver efficient and scalable solutions.",
  },
  {
    id: 2,
    title: "Front End",
    image: "frontend_blue.png",
    languages: [
      {
        id: 1,
        title: "JavaScript",
        css: "js",
      },
      {
        id: 2,
        title: "Vue.js",
        css: "vuejs",
      },
      {
        id: 3,
        title: "Bootstrap",
        css: "bootstrap",
      },
    ],
    description:
      "I have passion for designing web apps and websites with  JavaScript and Vue.js.",
  },
  {
    id: 3,
    title: "Android",
    image: "android.png",
    languages: [
      {
        id: 1,
        title: "Kotlin",
        css: "kotlin",
      },
      {
        id: 2,
        title: "Java",
        css: "java",
      },
      {
        id: 3,
        title: "Android",
        css: "android",
      },
    ],
    description:
      "I develop native android apps and work closely with modern android development best practises.",
  },
];

export default skills;
